module.exports = __webpack_public_path__ + "static/media/icon-app-store.8ad5f0fa.svg";